webpackJsonp([107163723044626],{

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Actions = __webpack_require__(44);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Actions2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'find'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This blueprint...'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Example usage is below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      lore.actions.tweet.find({\n        /* where data */\n      }, {\n        /* pagination data */\n      })\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Blueprint'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import _ from \'lodash\';\n      import { ActionTypes, PayloadStates, payloadCollection, normalize } from \'lore-utils\';\n\n      export default function find(query = {}, pagination) {\n        return function(dispatch) {\n          const Collection = lore.collections.{{ modelName }};\n          const collection = new Collection();\n\n          const queryParameters = _.extend({}, query, pagination);\n\n          const combinedQuery = {\n            where: query,\n            pagination: pagination\n          };\n\n          collection.fetch({\n            data: queryParameters\n          }).then(function() {\n            // look through all models in the collection and generate actions for any attributes\n            // with nested data that should be normalized\n            const actions = normalize(lore, \'{{ modelName }}\').collection(collection);\n\n            dispatch({\n              type: ActionTypes.fetchPlural(\'{{ modelName }}\'),\n              payload: payloadCollection(collection, PayloadStates.RESOLVED, null, combinedQuery),\n              query: combinedQuery\n            });\n\n            // dispatch any actions created from normalizing nested data\n            actions.forEach(dispatch);\n          }).catch(function(response) {\n            const error = response.data;\n\n            dispatch({\n              type: ActionTypes.fetchPlural(\'{{ modelName }}\'),\n              payload: payloadCollection(collection, PayloadStates.ERROR_FETCHING, error, combinedQuery),\n              query: combinedQuery\n            });\n          });\n\n          return dispatch({\n            type: ActionTypes.fetchPlural(\'{{ modelName }}\'),\n            payload: payloadCollection(collection, PayloadStates.FETCHING, null, combinedQuery),\n            query: combinedQuery\n          });\n        };\n      };\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-actions-find-js-3c468042a7e89679d5c2.js